// Global limit-paywall state. Populated by the axios interceptor in
// helpers/limitPaywall.js whenever the backend returns a structured
// resource_limit_reached 403; rendered by components/custom/LimitPaywallModal.vue.
export const state = {
  visible: false,
  limitName: null,
  limit: null,
  message: null,
  code: null,
  params: null,
  creditType: null
}

export const mutations = {
  SHOW(state, { limitName, limit, message, code, params, creditType }) {
    state.visible = true
    state.limitName = limitName
    state.limit = limit
    state.message = message
    state.code = code || null
    state.params = params || null
    state.creditType = creditType || null
  },
  HIDE(state) {
    state.visible = false
    state.limitName = null
    state.limit = null
    state.message = null
    state.code = null
    state.params = null
    state.creditType = null
  }
}

export const actions = {
  show({ commit }, payload) {
    commit('SHOW', payload)
  },
  hide({ commit }) {
    commit('HIDE')
  }
}
